import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholder: {
		id: 'polaris-common.fields.play.legacy.placeholder',
		defaultMessage: 'Vote',
		description: 'Vote button when the current user did not vote yet.',
	},
});
